<template>
  <widget title="Credit Holds">
    <template v-slot:content>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th>Client</th>
              <th>Age</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="hold in creditHolds.holds"
              :key="hold.custno"
            >
              <td>
                <client-code :custno="hold.custno"></client-code>
              </td>
              <td>{{ hold.age }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </widget>
</template>

<script>

import store from '@/store'
import Widget from './Widget'
import ClientCode from '../../clients/ClientCode'

export default {
  name: 'CreditHolds',
  data () {
    return {
      creditHoldFields: [
        {'key': 'custno', 'label': 'Client', 'data-custno': 'custno'},
        {'key': 'age', 'label': 'Age'}
      ]
    }
  },
  components: {
    Widget,
    ClientCode
  },
  computed: {
    creditHolds () {
      return store.state.dashboard.creditHolds
    }
  },
  beforeMount () {
    store.dispatch('dashboard/fetchCreditHolds')
  }
}
</script>

<style scoped>

</style>
